/**
 * Enhanced Size Selector with Size Guide
 * Improves the existing .sp-swatches-container UI for GK gloves
 * T1TAN-style enhancement
 */
(function() {
  'use strict';
  
  let sizeGuideModal = null;
  
  function enhanceSizeSelector() {
    const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
    if (!swatchesContainer) return;
    
    // Check if this is a size selector (not color)
    const sizeSwatches = swatchesContainer.querySelectorAll('ul.sp-options-swatch li a:not(.options-color)');
    if (sizeSwatches.length === 0) return;
    
    // Hide existing title if exists
    const existingTitle = swatchesContainer.querySelector('.sp-title-options');
    if (existingTitle) {
      existingTitle.style.display = 'none';
    }
    
    // Add size guide header if not exists, or ensure existing one is visible
    let sizeGuideHeader = swatchesContainer.querySelector('.size-guide-header');
    if (!sizeGuideHeader) {
      sizeGuideHeader = document.createElement('div');
      sizeGuideHeader.className = 'size-guide-header';
      sizeGuideHeader.innerHTML = `
        <label class="size-guide-label">
          サイズ
        </label>
      `;
      
      const firstWrapper = swatchesContainer.querySelector('.sp-wrapper');
      if (firstWrapper) {
        // Insert before the swatches list
        const swatchesList = firstWrapper.querySelector('ul.sp-options-swatch');
        if (swatchesList) {
          firstWrapper.insertBefore(sizeGuideHeader, swatchesList);
        } else {
          firstWrapper.insertBefore(sizeGuideHeader, firstWrapper.firstChild);
        }
      } else {
        swatchesContainer.insertBefore(sizeGuideHeader, swatchesContainer.firstChild);
      }
    }
    
    // ALWAYS ensure label stays visible (even if header already existed)
    const label = sizeGuideHeader.querySelector('.size-guide-label');
    if (label) {
      label.style.display = 'flex';
      label.style.visibility = 'visible';
      label.style.opacity = '1';
    }
    sizeGuideHeader.style.display = 'flex';
    sizeGuideHeader.style.visibility = 'visible';
    sizeGuideHeader.style.opacity = '1';
    
    // Size guide modal functionality removed - using existing size guide link below
    // Initialize size guide modal if not exists (for existing size guide link)
    initSizeGuideModal();
    
    // Disable only out of stock sizes (keep available sizes selectable)
    // Only run after a short delay to ensure swatches are fully loaded
    setTimeout(function() {
      disableOutOfStockSizes();
      
      // Re-ensure label visibility after DOM updates
      const labelAfterUpdate = swatchesContainer.querySelector('.size-guide-label');
      const headerAfterUpdate = swatchesContainer.querySelector('.size-guide-header');
      if (labelAfterUpdate) {
        labelAfterUpdate.style.display = 'flex';
        labelAfterUpdate.style.visibility = 'visible';
        labelAfterUpdate.style.opacity = '1';
      }
      if (headerAfterUpdate) {
        headerAfterUpdate.style.display = 'flex';
        headerAfterUpdate.style.visibility = 'visible';
        headerAfterUpdate.style.opacity = '1';
      }
    }, 300);
  }
  
  function disableOutOfStockSizes() {
    const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
    if (!swatchesContainer) return;
    
    const sizeSwatches = swatchesContainer.querySelectorAll('ul.sp-options-swatch li a:not(.options-color)');
    
    sizeSwatches.forEach(function(swatch) {
      const listItem = swatch.closest('li');
      if (!listItem) return;
      
      // Always remove unavailable class first to reset state
      listItem.classList.remove('unavailable');
      swatch.classList.remove('unavailable');
      swatch.removeAttribute('aria-disabled');
      swatch.removeAttribute('tabindex');
      
      // Check if this swatch is unavailable - be very conservative
      const dataAvailability = listItem.getAttribute('data-availability') || swatch.getAttribute('data-availability');
      const dataVariantAvailability = swatch.getAttribute('data-variant-availability');
      const variantId = swatch.getAttribute('data-variant-id') || swatch.getAttribute('data-var-id');
      
      let isUnavailable = false;
      
      // Method 1: Check data-availability attribute (most reliable)
      // Only mark as unavailable if explicitly "false" (string)
      if (dataAvailability === 'false') {
        isUnavailable = true;
      }
      
      // Method 2: Check data-variant-availability attribute
      // Only mark as unavailable if explicitly "false" (string)
      if (dataVariantAvailability === 'false') {
        isUnavailable = true;
      }
      
      // Method 3: Check global_quantity for inventory count
      // Only check if variantId exists and global_quantity is available
      // Be very careful - only mark as unavailable if inventory is explicitly 0
      if (!isUnavailable && variantId && typeof global_quantity !== 'undefined' && global_quantity[variantId] !== undefined) {
        const inventory = global_quantity[variantId];
        // Only mark as unavailable if inventory is exactly 0 (not null, not undefined, not "continue")
        if (inventory === 0 || inventory === '0') {
          isUnavailable = true;
        }
      }
      
      // Only disable if confirmed unavailable
      // Do NOT use href check as it's unreliable
      if (isUnavailable) {
        listItem.classList.add('unavailable');
        swatch.classList.add('unavailable');
        swatch.setAttribute('aria-disabled', 'true');
        swatch.setAttribute('tabindex', '-1');
        // CSS pointer-events: none will handle preventing clicks
      }
    });
  }
  
  function initSizeGuideModal() {
    if (sizeGuideModal) return;
    
    // Check if modal already exists in DOM (from size-guide-modal.liquid)
    sizeGuideModal = document.getElementById('sizeGuideModal');
    
    if (!sizeGuideModal) {
      // Wait a bit for the modal to be loaded
      setTimeout(function() {
        sizeGuideModal = document.getElementById('sizeGuideModal');
        if (sizeGuideModal) {
          setupModalEvents();
        }
      }, 500);
      return;
    }
    
    setupModalEvents();
  }
  
  function setupModalEvents() {
    if (!sizeGuideModal) return;
    
    // Add close functionality
    const closeBtn = sizeGuideModal.querySelector('.size-guide-modal-close');
    const overlay = sizeGuideModal.querySelector('.size-guide-modal-overlay');
    
    if (closeBtn && !closeBtn.hasAttribute('data-initialized')) {
      closeBtn.setAttribute('data-initialized', 'true');
      closeBtn.addEventListener('click', closeSizeGuideModal);
    }
    
    if (overlay && !overlay.hasAttribute('data-initialized')) {
      overlay.setAttribute('data-initialized', 'true');
      overlay.addEventListener('click', closeSizeGuideModal);
    }
    
    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sizeGuideModal && sizeGuideModal.classList.contains('active')) {
        closeSizeGuideModal();
      }
    });
  }
  
  function openSizeGuideModal() {
    if (!sizeGuideModal) {
      sizeGuideModal = document.getElementById('sizeGuideModal');
    }
    
    if (!sizeGuideModal) {
      // Try to initialize again
      initSizeGuideModal();
      setTimeout(function() {
        sizeGuideModal = document.getElementById('sizeGuideModal');
        if (sizeGuideModal) {
          sizeGuideModal.style.display = 'block';
          // Trigger reflow for animation
          sizeGuideModal.offsetHeight;
          requestAnimationFrame(function() {
            sizeGuideModal.classList.add('active');
            document.body.style.overflow = 'hidden';
          });
        }
      }, 100);
      return;
    }
    
    sizeGuideModal.style.display = 'block';
    // Trigger reflow for animation
    sizeGuideModal.offsetHeight;
    requestAnimationFrame(function() {
      sizeGuideModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  function closeSizeGuideModal() {
    if (sizeGuideModal) {
      sizeGuideModal.classList.remove('active');
      document.body.style.overflow = '';
      // Wait for animation to complete before hiding
      setTimeout(function() {
        if (sizeGuideModal && !sizeGuideModal.classList.contains('active')) {
          sizeGuideModal.style.display = 'none';
        }
      }, 300);
    }
  }
  
  // Initialize when DOM is ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceSizeSelector);
    } else {
      enhanceSizeSelector();
    }
    
    // Re-initialize when swatches are loaded (they're dynamically generated)
    const observer = new MutationObserver(function(mutations) {
      let shouldEnhance = false;
      let headerWasRemoved = false;
      
      mutations.forEach(function(mutation) {
        // Check for removed nodes - if header was removed, restore it immediately
        if (mutation.removedNodes.length) {
          mutation.removedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the removed node is the header or contains it
              if (node.classList && node.classList.contains('size-guide-header')) {
                headerWasRemoved = true;
              } else if (node.querySelector && node.querySelector('.size-guide-header')) {
                headerWasRemoved = true;
              }
            }
          });
        }
        
        // Check for added nodes
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('sp-options-swatch') ||
                node.querySelector && node.querySelector('.sp-options-swatch')
              )) {
                shouldEnhance = true;
              }
            }
          });
        }
      });
      
      // If header was removed, restore it immediately (synchronously to prevent flicker)
      if (headerWasRemoved) {
        const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
        if (swatchesContainer && !swatchesContainer.querySelector('.size-guide-header')) {
          // Immediately restore the header without delay
          enhanceSizeSelector();
        }
      }
      
      if (shouldEnhance) {
        setTimeout(function() {
          enhanceSizeSelector();
          // Delay disable check to ensure swatches are fully loaded
          setTimeout(function() {
            disableOutOfStockSizes();
            // Ensure label stays visible after re-enhancement
            const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
            if (swatchesContainer) {
              const label = swatchesContainer.querySelector('.size-guide-label');
              const header = swatchesContainer.querySelector('.size-guide-header');
              if (label) {
                label.style.display = 'flex';
                label.style.visibility = 'visible';
                label.style.opacity = '1';
              }
              if (header) {
                header.style.display = 'flex';
                header.style.visibility = 'visible';
                header.style.opacity = '1';
              }
            }
          }, 200);
        }, 100);
      }
    });
    
    // Add click listener to ensure label stays visible when sizes are clicked
    document.addEventListener('click', function(e) {
      const clickedSize = e.target.closest('.sp-product-single-info .sp-swatches-container ul.sp-options-swatch li a:not(.options-color)');
      if (clickedSize) {
        // Ensure label stays visible after click
        setTimeout(function() {
          const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
          if (swatchesContainer) {
            const label = swatchesContainer.querySelector('.size-guide-label');
            const header = swatchesContainer.querySelector('.size-guide-header');
            if (label) {
              label.style.display = 'flex';
              label.style.visibility = 'visible';
              label.style.opacity = '1';
            }
            if (header) {
              header.style.display = 'flex';
              header.style.visibility = 'visible';
              header.style.opacity = '1';
            }
          }
        }, 50);
      }
    }, true);
    
    const swatchesContainer = document.querySelector('.sp-product-single-info .sp-swatches-container');
    if (swatchesContainer) {
      observer.observe(swatchesContainer, { 
        childList: true, 
        subtree: true 
      });
    }
    
    // Also check periodically for dynamically loaded swatches
    let checkCount = 0;
    const checkInterval = setInterval(function() {
      checkCount++;
      enhanceSizeSelector();
      // Delay disable check to ensure swatches are fully loaded
      setTimeout(disableOutOfStockSizes, 200);
      
      // Stop checking after 5 seconds
      if (checkCount >= 10) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
  
  init();
})();

